import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import { DaysStyled } from './styled'
import Value from '../Value'

const Days = ({ daysLength, icon, items }) => {
    return (
        <DaysStyled
            daysLength={daysLength}
        >
            {
                icon &&
                <Icon name={icon} />
            }
            {
                items &&
                items.map((item, index) => (
                    <Value 
                        key={item.stamp || index}
                        item={item}
                    />
                ))
            }
        </DaysStyled>
    )
}

Days.propTypes = {
    items: PropTypes.array,
}

export default Days